// src/locales/en/warehouses.js
export const warehouses = {
    
    createNewWarehouse: "புதிய கிடங்கை உருவாக்கு",
    setupYourWarehouse: "உங்கள் கிடங்கின் விவரங்கள் மற்றும் தகவல்களை அமைக்கவும்",
    backToWarehouses: "கிடங்குகளுக்கு திரும்பு",
    
    basicInformation: "அடிப்படை தகவல்",
    basicInformationDesc: "உங்கள் கிடங்கு பற்றிய அடிப்படை விவரங்களை வழங்கவும்",
    warehouseName: "கிடங்கின் பெயர்",
    warehouseNamePlaceholder: "கிடங்கின் பெயரை உள்ளிடுங்கள் (எ.கா: முக்கிய கிடங்கு, சேமிப்பு அலகு A)",
    addressPlaceholder: "முழுமையான கிடங்கு முகவரியை உள்ளிடுங்கள்...",
    addressHint: "சிறந்த அடையாளத்திற்காக தெரு முகவரி, நகரம் மற்றும் அஞ்சல் குறியீட்டை சேர்க்கவும்",
    phonePlaceholder: "தொடர்பு எண்ணை உள்ளிடுங்கள்",
    phoneHint: "கிடங்கு நடவடிக்கைகள் மற்றும் ஒருங்கிணைப்புக்கான தொடர்பு எண்",
    phone: "தொலைபேசி எண்",
    address: "முகவரி",
    
    nameRequired: "கிடங்கின் பெயர் தேவை",
    nameMinLength: "கிடங்கின் பெயர் குறைந்தது 2 எழுத்துகளாக இருக்க வேண்டும்",
    invalidPhone: "தயவுசெய்து சரியான தொலைபேசி எண்ணை உள்ளிடுங்கள்",
    
    createWarehouse: "கிடங்கை உருவாக்கு",
    
    warehouseCreatedSuccess: "'{{warehouseName}}' கிடங்கு வெற்றிகரமாக உருவாக்கப்பட்டது!",
    failedToCreate: "கிடங்கை உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",

    manageYourWarehouses: "உங்கள் அனைத்து கிடங்குகள் மற்றும் அவற்றின் தகவல்களை நிர்வகிக்கவும்",
    loadingWarehouses: "கிடங்குகள் ஏற்றப்படுகின்றன...",
    loadingWarehousesDesc: "உங்கள் கிடங்குகளைப் பெறும்போது தயவுசெய்து காத்திருங்கள்.",
    searchWarehouses: "பெயர், முகவரி அல்லது தொலைபேசி மூலம் கிடங்குகளைத் தேடுங்கள்...",
    filteredResults: "{{total}} இல் {{count}} கிடங்குகள்",
    totalWarehouses: "{{count}} கிடங்குகள்",
    allWarehouses: "அனைத்து கிடங்குகள்",
    noSearchResults: "கிடங்குகள் கிடைக்கவில்லை",
    noSearchResultsDesc: "உங்கள் தேடல் சொற்களை சரிசெய்ய முயற்சிக்கவும் அல்லது அனைத்து கிடங்குகளையும் பார்க்க வடிகட்டிகளை அழிக்கவும்.",
    noWarehouses: "இன்னும் கிடங்குகள் இல்லை",
    noWarehousesDesc: "உங்கள் சரக்கு இடங்களை நிர்வகிக்கத் தொடங்க உங்கள் முதல் கிடங்கை உருவாக்கவும்.",
    createFirstWarehouse: "முதல் கிடங்கை உருவாக்கு",
    
    contact: "தொடர்பு",
    
    noContact: "தொடர்பு தகவல் இல்லை",
    
    confirmDelete: "'{{warehouseName}}' கிடங்கை நீக்க விரும்புகிறீர்களா? இந்த செயலை மாற்ற முடியாது.",
    warehouseDeletedSuccess: "'{{warehouseName}}' கிடங்கு வெற்றிகரமாக நீக்கப்பட்டது.",
    failedToDelete: "கிடங்கை நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",

    addWarehouse: "கிடங்கு சேர்க்கவும்",
    editWarehouse: "கிடங்கை திருத்தவும்",
    updateWarehouse: "கிடங்கை புதுப்பிக்கவும்", 
    warehouseUpdatedSuccess: "'{{warehouseName}}' கிடங்கு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
    failedToUpdate: "கிடங்கை புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
    failedToLoadWarehouse: "கிடங்கு விவரங்களை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
}